import i18n from "../../../i18n";

export const initialState = {
    i18n,
    stockDetails: ""
};

const state = { ...initialState };

export default state;